import Button from "./Button";

interface ConfirmPartnerDialogProps {
  isOpen: boolean;
  currentPartnerName: string;
  newPartnerName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmPartnerDialog = ({
  isOpen,
  currentPartnerName,
  newPartnerName,
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmPartnerDialogProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={!isLoading ? onCancel : undefined}
      />

      {/* Dialog */}
      <div
        data-testid="confirm-partner-dialog"
        className="relative bg-white rounded-lg shadow-xl mx-4 max-w-md w-full p-6"
      >
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Change Partner Association?
        </h2>

        <p className="text-gray-600 mb-6">
          You are currently associated with{" "}
          <span className="font-semibold text-gray-900">{currentPartnerName}</span>.
          Do you want to switch to{" "}
          <span className="font-semibold text-primaryOrange">{newPartnerName}</span>?
        </p>

        <div className="flex gap-3 justify-end">
          <Button
            htmlType="button"
            onClick={onCancel}
            isDisabled={isLoading}
            variant="outline"
            type="standard"
            size="sm"
            data-testid="keep-current-partner"
          >
            Keep Current
          </Button>
          <Button
            htmlType="button"
            onClick={onConfirm}
            isDisabled={isLoading}
            isLoading={isLoading}
            variant="primary"
            type="standard"
            size="sm"
            data-testid="switch-partner"
          >
            Switch Partner
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPartnerDialog;
